import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { GroupGoal } from 'src/app/models/group-goal.model';
import { GroupGoalsData } from 'src/app/models/group-goals-data.model';
import { GroupGoalService } from 'src/app/services/group-goal.service';
import { ISelectorDialogModel, ISelectorDialogResult, SelectorDialogComponent } from 'src/app/shared/components';
import { ISelectorListItem } from 'src/app/shared/models/selector-list-item.model';

@Component({
  selector: 'app-group-goal-field',
  templateUrl: './group-goal-field.component.html',
  styleUrls: ['./group-goal-field.component.scss']
})
export class GroupGoalFieldComponent implements OnInit {

  @Input()
  public data: GroupGoalsData;

  @Input()
  public groupGoal: GroupGoal;    //ez maga az adott felettes csapatcélja

  @Input() 
  public isDisabled: boolean;

  @Input()
  public editLabel = 'GROUP_GOAL_FIELD.ASSIGN_TEAM_GOAL';

  @Output()
  public change = new EventEmitter<GroupGoal>();

  public get groupGoalDisplayText(): string {
    if (!this.groupGoal) return null;
    
    return this.groupGoal.employeeName + ': ' + this.groupGoal.name;
  }
  
  constructor(public dialog: MatDialog, public groupGoalService: GroupGoalService, private cd: ChangeDetectorRef) { }

  ngOnInit(): void {
  }  

  public toListItem(groupGoal: GroupGoal): ISelectorListItem {
    if (!groupGoal) return null;

    return groupGoal ? {
        id: groupGoal.id,
        text: this.formatGroupGoal(groupGoal)
    } as ISelectorListItem : null;
  }

  selectGroupGoal() {
    //popup
    if (this.isDisabled) return;

    this.groupGoalService.getLeaderGroupGoals(this.data.goalPeriodId).subscribe((result) => {
        
        let items = result.map((item) => this.toListItem(item));

        items = [{ id: null, text: 'Not selected' }, ...items];

        const dialogRef = this.dialog.open(SelectorDialogComponent, {
            width: '840px',            
            data: { title: 'Leader\'s team goals', selected: this.toListItem(this.groupGoal), items: items } as ISelectorDialogModel
          });
      
          dialogRef.afterClosed().subscribe( (dialogResult: ISelectorDialogResult) => {

            // ok lett nyomva
            if (dialogResult) {
              this.groupGoal = dialogResult.selectedItem ? result.find(x => x.id === dialogResult.selectedItem) : null;
              this.cd.detectChanges(); 

              this.change.emit(this.groupGoal);
            }
          });
    });

  }

  formatGroupGoal(groupGoal: GroupGoal): string {
    let result = '';    
    
    if (groupGoal.parentGroupGoal) {
      result += this.formatGroupGoal(groupGoal.parentGroupGoal);
    }

    result += `<strong>${groupGoal.employeeName}</strong>: ${groupGoal.name}<br>`;
    return result;
  }
}
